import type {FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';

import {ImageBlock} from '@/modules/foundation/components/image/ImageBlock';

import type {ProductInCard} from '../../shared/types';
import type {SpecialProduct} from '../product-list';

type Props = {
	product: ProductInCard;
};

export const ProductCard: FC<Props> = ({product}) => {
	const {title, href, imageWeb} = product;

	return (
		<Link
			href={href}
			className={clsx(
				'flex',
				'flex-col',
				'justify-between',
				'shadow-md',
				'hover:shadow-xl',
				'rounded-md',
				'p-4',
				'h-full',
				'uppercase',
				'gap-4',
			)}
		>
			{imageWeb && (
				<ImageBlock
					height={imageWeb.image.height}
					src={imageWeb.image.src}
					width={imageWeb.image.width}
					alt={imageWeb.altText ?? ''}
				/>
			)}
			{title}
		</Link>
	);
};

type SpecialProductProps = {product: SpecialProduct};

export const SpecialProductCard: FC<SpecialProductProps> = ({product}) => {
	const {title, href, image} = product;

	return (
		<Link
			href={href}
			className={clsx(
				'flex',
				'flex-col',
				'justify-between',
				'shadow-md',
				'hover:shadow-xl',
				'rounded-md',
				'p-4',
				'h-full',
				'uppercase',
				'gap-4',
			)}
		>
			{image && (
				<ImageBlock
					height={image.image.height}
					src={image.image.src}
					width={image.image.width}
					alt={image.altText ?? ''}
				/>
			)}
			{title}
		</Link>
	);
};
